var React = require('react');

function FussFreeClaims (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Fuss free claims"),React.createElement("g",{"id":"cfLayer_1","key":1},[React.createElement("path",{"d":"M36.2 7h-17c-3.9 0-7.2 3.2-7.2 7.1v32c0 3.9 3.3 6.9 7.2 6.9h22c3.9 0 6.8-3 6.8-6.9v-26c0-.6.1-2.6-4.4-7.7C38.9 7 37 7 36.2 7zM45 46.1c0 2.2-1.6 3.9-3.8 3.9h-22C17 50 15 48.3 15 46.1v-32c0-2.2 2-4.1 4.2-4.1H34v6.1c0 3.9 2.3 5.9 6.2 5.9H45v24.1zM40.2 20C38 20 36 18.3 36 16.1v-6c2 0 9.2 7.9 9.2 9.9h-5z","key":0}),React.createElement("path",{"d":"M26.5 37.9l-6-6-3 3 9 9 15-15-3-3z","key":1})])]);
}

FussFreeClaims.defaultProps = {"viewBox":"0 0 60 60","id":"fuss-free-claims","width":"100%","height":"100%"};

module.exports = FussFreeClaims;

FussFreeClaims.default = FussFreeClaims;
